import { render, staticRenderFns } from "./AppDealers.vue?vue&type=template&id=b9a6a8d6&scoped=true&"
import script from "./AppDealers.vue?vue&type=script&lang=js&"
export * from "./AppDealers.vue?vue&type=script&lang=js&"
import style0 from "./AppDealers.vue?vue&type=style&index=0&id=b9a6a8d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a6a8d6",
  null
  
)

export default component.exports